import { useIsNative } from '~/context/common/DeviceContext';
import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';

export const VDP_SPA_EXPERIMENT = 'car-merch-ui-srp-vdp-spa-v2';

export default function useIsInVdpSpaExperiment(): boolean {
  const bucket = useExperimentBucket(VDP_SPA_EXPERIMENT);
  const isNative = useIsNative();

  return !isNative && bucket === 'treatment';
}
